import React from 'react'
import styled from 'styled-components'
import { FooterSubscribes } from '../FooterSubscribes/FooterSubscribes'
import { FooterMainSection } from '../FooterMainSection/FooterMainSection'
import { FooterLinks } from '../FooterLinks/FooterLinks'
import { FooterBottomSection } from '../FooterBottomSection/FooterBottomSection'

export const Footer = () => {
  return (
    <FooterElement data-site-area='footer' id='reactFooter'>
      <FooterSubscribes />
      <FooterMainSection />
      <FooterLinks />
      <FooterBottomSection />
    </FooterElement>
  )
}

const FooterElement = styled.footer`
  width: 100%;
  @media print {
    display: none;
  }
`
